export default __webpack_public_path__ + "static/media/invite_user_icon.c0f4845e.svg";